import { categoriesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories";
import { css } from "styled-components";

categoriesStyles.container = {
    css: css`
        margin: 10px;
    `,
};

categoriesStyles.categoryImageItem = {
    width: 12,
    align: "middle",
    css: css`
        width: 100%;
        height: 160px;
        justify-content: center;
        > a[class^="StyledButton"] {
            > span[class^="TypographyStyle"] {
                > div[class^="LazyImageStyle"] {
                    margin: 10px 0;
                    > img {
                        height: 150px;
                    }
                }
            }
        }
    `,
};

categoriesStyles.categoryNameLink = {
    typographyProps: {
        weight: "bold",
        css: css`
            width: 100%;
            overflow-wrap: break-word;
            word-wrap: break-word;
            text-align: center;
        `,
    },
    color: "text.main",
    css: css`
        width: 100%;
    `,
};

categoriesStyles.subCategoryLink = {
    typographyProps: {
        css: css`
            width: 100%;
            overflow-wrap: break-word;
            word-wrap: break-word;
            text-align: center;
        `,
    },
    css: css`
        width: 100%;
    `,
};
